












import { computed, defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';

export default defineComponent({
    name: 'DifferencesSwitch',
    setup () {
        const store = useStore();
        const isDiffDisplaying = computed(() => store.state.isDisplayingDifference);

        const switchChanged = (event: Event) => {
            store.dispatch(ActionTypes.SetIsDisplayingDifference, (event.target as HTMLInputElement).checked);
        };

        return { isDiffDisplaying, switchChanged };
    }
});
